import React from "react";
import { makeStyles } from "@material-ui/core";

import { i18n } from "../../../translate/i18n";
import TemplateDefaultImg from "../../../assets/miscPng/templateDefault.png";

const useStyles = makeStyles((theme) => ({
  templateDefaultMainContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
  },

  templateDefaultMainContainerDeleted: {
    opacity: 0.7,
    filter: "grayscale(80%)",
  },

  templateDefaultContentContainer: {
    width: "100.00%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    gap: "5px",
    borderRadius: "5px",
    padding: "3px",
  },

  templateDefaultLogo: {
    width: "50px",
    height: "50px",
    borderRadius: "50.00%",
  },

  templateDefaultContentMessageContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    gap: "3px",
  },
}));

const TemplateDefault = ({ message }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();
  const mainContainerClassName = message.isDeleted
    ? `${classes.templateDefaultMainContainer} ${classes.templateDefaultMainContainerDeleted}`
    : `${classes.templateDefaultMainContainer}`;



  //  ************
  //  ** Return **
  //  ************
  return (
    <div className={mainContainerClassName}>
      <div className={classes.templateDefaultContentContainer}>
        <img alt="Template Default Logo" src={TemplateDefaultImg} className={classes.templateDefaultLogo} />

        <div className={classes.templateDefaultContentMessageContainer}>
          <span>
            {i18n
              .t("messageBodyWrapper.templateDefault")
              .replace(
                "<action>"
                , message.fromMe ? i18n.t("messageBodyWrapper.messageActions.sent") : i18n.t("messageBodyWrapper.messageActions.received")
              )}
          </span>
        </div>
      </div>
    </div>
  );
};

export default TemplateDefault;
